import axios from "axios";
import errorCode from "@/utils/errors";
import { getToken , removeTokenAndInfo } from "./cookie";
import { Message,Notification } from 'element-ui';


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const baseApi = '/api'; 

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: baseApi,
  // 超时
  timeout: 21600000
});


/**
 * 拦截器
 */
service.interceptors.request.use(config => {
    let searchObj = window.location.search? getParameters(window.location.search):{}
    const token = getToken();
    if (token != null && token != '') {
        config.headers['Authorization'] = token; // 让每个请求携带自定义token 请根据实际情况自行修改
    } else {

    }
    //config.headers['BrowserId'] = BrowserId || localStorage.getItem('BrowserId')
      // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?' + tansParams(config.params);
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config
  }, error => {
      console.log(error)
      Promise.reject(error)
});






/**
 * 响应拦截器
 */
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if(res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer'){
       return res.data
    }
    if (code === 401) {

        Message.info('登录状态已过期，需重新登录.');
        removeTokenAndInfo();
        window.location.href = '/login';
        return Promise.reject('无效的会话，或者会话已过期，请重新登录。')

    } else if (code === 500) {

      console.error(msg);
      return Promise.resolve(res.data);

    } else if (code !== 200) {

      Notification.error({title: msg});
      return Promise.reject('error')

    } else {

      return Promise.resolve(res.data)
      
    }
  },
  error => {
    let { message } = error;
    if (message == "Network Error") {
        message = "服务端接口连接异常";
    } else if (message.includes("timeout")) {
        message = "服务端接口请求超时";
    } else if (message.includes("Request failed with status code")) {
        message = "服务端接口" + message.substr(message.length - 3) + "异常";
    }
    Message({ message: message, type: 'error', duration: 5 * 1000 });
    return Promise.reject(error)
  }
)




/**
 * 获取URL参数
 * @param {*} str 
 * @returns 
 */
function getParameters(str){
    try {
        return JSON.parse(`{"${decodeURI(str.split("?")[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`)
    }catch (e) {
        return {}
    }
}

/**
 * 参数转换
 * @param {*} params 
 * @returns 
 */
function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}

export default service;


// WEBPACK FOOTER //
// ./src/request.js